import { useState } from "react";
import axios from "axios";
import config from "config/config";

const useSendContactUsEmail = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);
  const [error, setError] = useState(null);


  const formatFormDataToHTML = (formData) => {
    const { firstName, lastName, email, company, message } = formData;

    return `
      <p><strong>First Name:</strong> ${firstName}</p>
      <p><strong>Last Name:</strong> ${lastName}</p>
      <p><strong>Email:</strong> ${email}</p>
      <p><strong>Company:</strong> ${company}</p>
      <p><strong>Message:</strong> ${message}</p>
    `;
  };

  const sendEmail = async (formData) => {
    setIsLoading(true);
    setIsSuccess(null);
    setError(null);

    const { captchaToken, website, ...emailFormData } = formData;
    const formHTML = formatFormDataToHTML(emailFormData);

    try {
      await axios.post(`${config.API_BASE_URL}/send-email`, {
        ...emailFormData,
        captchaToken,
        website,
        html: formHTML,
        subject: emailFormData.company ? `Contact form / Akyga battery x ${emailFormData.company}` : "Contact form / Akyga battery",
        email: emailFormData.email,
        supportEmail: "sales@akygabattery.com"
      });
      setIsSuccess(true);
    } catch (err) {
      setIsSuccess(false);
      setError(err);
      console.error('There was an error sending the email:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return { sendEmail, isLoading, isSuccess, error };
};

export default useSendContactUsEmail;
